export enum MediumEnum {
  JUPITER_DESKTOP = 'Jupiter-desktop',
  JUPITER_WEB = 'Jupiter-web',
  WEB = 'web',
}
